import React from 'react';
import FlujoFondos from './FlujoFondos';

export default function FlujoFondosAnalisisPage() {
  return <FlujoFondos initialSection="analisis" />;
}
